import React, { useContext } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useFeatureIsOn, useFeatureValue } from '@growthbook/growthbook-react';
import { GrowthBookFeature } from '@gumtree/shared/src/model/experiment';
import type { VipState } from '../../reducers';
import revealPhoneUtil from './reveal-phone-util';
import ContactButtons from '../contact-buttons/contact-buttons';
import {
    ButtonGroup,
    ContainerNew,
} from './style';
import SellerPhoneRevealLogic from './seller-phone-reveal-logic';
import { RequestAQuoteFormContext } from '../../vip-context';

export const SellerContactBlock: React.FC = () => {
    const {
        adDetails,
        baseConfig,
        sellerContactDetails: {
            replyPhone,
            replySmsEnabled,
            replyLink,
            replyEmail,
        }
    } = useSelector(
        ({ adDetails, baseConfig, sellerContactDetails, requestId }: VipState) => ({
            adDetails,
            baseConfig,
            sellerContactDetails,
            isMotors: adDetails.l1CategorySeoName === 'cars-vans-motorbikes',
            isFromMotorsFeed: adDetails.isFromMotorsFeed,
            requestId
        }),
        shallowEqual
    );

    const makeAnOfferEnabled = useSelector(
        ({ sellerActions }: VipState) => sellerActions.makeAnOfferEnabled
    );
    const isMobile = baseConfig.device?.type === 'mobile';
    const isServices = adDetails.l1CategorySeoName === 'business-services';
    const isUI_202506 = useFeatureValue(GrowthBookFeature.SERVICE_NEW_UI, 'A') === 'B' && isServices;

    const { adSource } = useContext(RequestAQuoteFormContext);
    const hideSMS = useFeatureIsOn(GrowthBookFeature.HIDE_SMS) && adDetails.isFromMotorsFeed;

    const isBarkAd = adSource === 'Bark';

    const buttonGroupProps = isBarkAd 
        ? { canCall: false, canSms: false, canOffer: false }
        : { 
            canCall: isMobile && !!replyPhone,
            canSms: isMobile && replySmsEnabled && !hideSMS,
            canOffer: !!replyEmail && makeAnOfferEnabled
          };

    const contactButtonsReplySmsEnabled = isBarkAd 
        ? false 
        : replySmsEnabled && !hideSMS && !isUI_202506;

    return (
        <ContainerNew className="seller-info-block-container">
            {(!isMobile && replyPhone || isBarkAd) && <SellerPhoneRevealLogic />}

            <ButtonGroup {...buttonGroupProps}>
                <ContactButtons
                    replyLink={replyLink}
                    replyEmail={replyEmail}
                    replyPhone={replyPhone}
                    replySmsEnabled={contactButtonsReplySmsEnabled}
                    revealPhoneUtil={revealPhoneUtil}
                    isMobile={isMobile}
                    l1CategorySeoName={adDetails.l1CategorySeoName}
                />
            </ButtonGroup>
        </ContainerNew>
    );
};

SellerContactBlock.defaultProps = {
    revealNumberUnmasked: null,
    replyPhone: undefined,
};

export default SellerContactBlock;
